import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Perso(){
    const settings = {
        arrows: true,
        dots: true,
        mobileFirst: true,
        swipeToSlide: true,
        touchMove: true,
        cssEase: "ease-out",
        adaptiveHeight: true,
    }

    return(
        <Slider {...settings}>
            <article>
                <h3 className="mt-2em">Voyage Amérique du sud</h3>
                <p className="text-blue">Octobre - Décembre 2017</p>
                <p>Séjour linguistique en Amérique Latine (Pérou, Bolivie, Argentine)</p>
            </article>
            <article>
                <h3 className="mt-2em">Missions de volontariat au Chili</h3>
                <p className="text-blue">Juillet - Octobre 2016</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Accueil en maison d'hôte</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Diverses constructions</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Jardinage</p>
                <p className="ul-list"><img src="/img/icons/blue-arrow.svg" className="blue-arr" />Vendanges et aide à la production de vin</p>
            </article>
            <article>
                <h3 className="mt-2em">Expatriation en Amérique Latine</h3>
                <p className="text-blue">De ma naissance à mes 8 ans</p>
                <p>Pérou, Colombie, Mexique</p>
            </article>
        </Slider>
    )
}

export default Perso
